import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

interface TabField {
  fieldName: string;
  fieldType: string;
  fieldLabel: string;
  placeholder?: string;
  options?: any[];
  value?: any;
  defaultValue?: any;
  required?: boolean;
  min?: number;
  max?: number;
  step?: number;
  fullWidth?: boolean;
  decimalSupport?: boolean;
  conditional?: {
    dependsOn: string;
    showWhen: any;
  };
}

interface TabSection {
  type: string;
  sectionTitle?: string;
  fields: TabField[];
}

interface Tab {
  fieldLabel: string;
  tabKey: string; // Add unique key for each tab
  sections: TabSection[];
}

@Component({
    selector: "app-navigation-tabs",
    templateUrl: "./navigation-tabs.component.html",
    styleUrls: ["./navigation-tabs.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigationTabsComponent implements OnInit {
  @Input() tabs: string[] = [];
  @Input() tabsData: Tab[] = [];
  @Input() activeTab: string | null = null;
  @Input() disabledTabs: string[] = [];
  @Input() disabled: boolean = false;
  @Input() formGroup: UntypedFormGroup; // Add FormGroup input
  @Output() tabChange = new EventEmitter<string>();
  @Output() fieldChange = new EventEmitter<{ field: string; value: any }>();

  ngOnInit() {
    if (!this.activeTab && this.tabs.length > 0) {
      this.activeTab = this.tabs[0];
    }
  }

  selectTab(tab: string) {
    if (this.isDisabled(tab)) return;
    this.activeTab = tab;
    this.tabChange.emit(tab);
  }

  isDisabled(tab: string): boolean {
    return this.disabledTabs && this.disabledTabs.includes(tab);
  }

  getActiveTabData(): Tab | null {
    if (!this.activeTab || !this.tabsData) return null;
    return (
      this.tabsData.find((tab) => tab.fieldLabel === this.activeTab) || null
    );
  }
}
